import { render, staticRenderFns } from "./Appeals.vue?vue&type=template&id=216eed91&scoped=true&"
import script from "./Appeals.vue?vue&type=script&lang=ts&"
export * from "./Appeals.vue?vue&type=script&lang=ts&"
import style0 from "./Appeals.vue?vue&type=style&index=0&id=216eed91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216eed91",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
